import { getCurrentBrandFromLocalStorage, setCurrentBrandInLocalStorage } from "helpers/sf_utils"
import {
  GET_BRANDS,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_ERROR,
  CREATE_BRAND,
  CREATE_BRAND_SUCCESS,
  CREATE_BRAND_ERROR,
  UPDATE_CURRENT_BRAND,
  RESET_BRAND_ERROR,
  UPDATE_BRAND,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_ERROR,
  GET_BRANDS_TRANSACTIONS,
  GET_BRANDS_TRANSACTIONS_SUCCESS,
  GET_BRANDS_TRANSACTIONS_ERROR
} from "./actionTypes"

const INIT_STATE = {
  current_brand: null,
  brands: [],
  error: null,
  loading: false,
  update_brand_loading: false,
  brand_transactions: [],
  loading_brand_transactions: false
}
const Brands = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BRANDS:
      return {
        ...state,
        error: null,
        loading: true,
        update_brand_loading: false
      }

    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        error: null,
        brands: action.payload,
        loading: false,
        update_brand_loading: false,
        current_brand: getCurrentBrandFromLocalStorage()
      }

    case GET_BRANDS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        update_brand_loading: false,
        brands: [],
        current_brand: null
      }
    case GET_BRANDS_TRANSACTIONS:
      return {
        ...state,
        error: null,
        loading_brand_transactions: true,
      }

    case GET_BRANDS_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        error: null,
        brand_transactions: action.payload,
        loading_brand_transactions: false,
      }

    case GET_BRANDS_TRANSACTIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_brand_transactions: false
      }
    case CREATE_BRAND:
      return {
        ...state,
        loading: true,
        update_brand_loading: false

      }
    case CREATE_BRAND_SUCCESS:
      return {
        ...state,
        brands: [...state.brands, action.payload],
        loading: false,
        update_brand_loading: false

      }

    case CREATE_BRAND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        update_brand_loading: false

      }

    case UPDATE_CURRENT_BRAND:
      return {
        ...state,
        current_brand: action.payload.brand

      }

    case RESET_BRAND_ERROR:
      return {
        ...state,
        error: null
      }

    case UPDATE_BRAND:
      return {
        ...state,
        loading: false,
        update_brand_loading: true

      }
    case UPDATE_BRAND_SUCCESS:
      if (action.payload.id?.toString() === state.current_brand.id?.toString()) {
        setCurrentBrandInLocalStorage(action.payload)
      }
      return {
        ...state,
        brands: state.brands.map(brand => brand.id == action.payload.id
          ? { brand, ...action.payload }
          : brand,
        ),
        current_brand: action.payload.id?.toString() === state.current_brand.id?.toString() ?
          action.payload : state.current_brand,
        loading: false,
        update_brand_loading: false

      }

    case UPDATE_BRAND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        update_brand_loading: false

      }



    default:
      return state
  }
}

export default Brands
